<ng-container *ngIf="isActionsSection()">
    <div [ngClass]="section.panelClass">
        <ng-container *ngFor="let row of section.rows">
            <div [ngClass]="row.panelClass" [matTooltip]="row.tooltip ? (row.tooltip | translate) : ''">
                <ng-container *ngFor="let fieldId of row.fields">
                    <ng-container *ngIf="getActionField(fieldId) as field">
                        <ng-container [ngSwitch]="field.type">
                            <!-- Button UI Elements -->
                            <ng-container *ngSwitchCase="RowItemType.UI" [ngSwitch]="field.uiType">
                                <button
                                    *ngSwitchCase="UIElementType.Button"
                                    mat-button
                                    type="button"
                                    [disabled]="getDisabledSelector(fieldId) | async"
                                    [ngClass]="field.panelClass"
                                    [matTooltip]="field.tooltip | translate"
                                    (click)="handleFieldEvent(field, 'onClick', $event)"
                                >
                                    <mat-icon *ngIf="field.iconName">{{ field.iconName }}</mat-icon>
                                    <img
                                        *ngIf="field.enabledImgSrc"
                                        [ngSrc]="field.enabledImgSrc"
                                        [height]="field.imgHeight || 24"
                                        [width]="field.imgWidth || 24"
                                        alt=""
                                        [ngClass]="field.enabledImgClass"
                                        class="activate-enabled-img"
                                    />
                                    <img
                                        *ngIf="field.imgSrc"
                                        [ngSrc]="field.imgSrc"
                                        [height]="field.imgHeight || 24"
                                        [width]="field.imgWidth || 24"
                                        [alt]="field.imgAlt || ''"
                                        [ngClass]="[field.imgClass, field.enabledImgSrc ? 'activate-disabled-img' : '']"
                                    />
                                    <span class="btn-label">
                                        {{ field.label | translate }}
                                    </span>
                                    <span *ngIf="field.suffixText" [ngClass]="field.suffixTextClass">
                                        ({{ field.suffixText | translate }})
                                    </span>
                                </button>
                                <!-- Menu Element -->
                                <app-menu-element
                                    *ngSwitchCase="UIElementType.Menu"
                                    [field]="field"
                                    [isReadOnly]="isReadOnly"
                                >
                                </app-menu-element>
                                <!-- Divider Element -->
                                <app-divider-element
                                    *ngSwitchCase="UIElementType.Divider"
                                    [field]="field"
                                    [isReadOnly]="isReadOnly"
                                ></app-divider-element>
                                <!-- Component Element -->
                                <ng-container *ngSwitchCase="UIElementType.Component">
                                    <span
                                        *ngIf="field.componentId === 'diagnostics-menu' && (diagnosticsVisible$ | async)"
                                        [matTooltip]="field.tooltip | translate"
                                        matTooltipPosition="above"
                                        [class.disabled]="getDisabledSelector(fieldId) | async"
                                    >
                                        <app-diagnostics-menu
                                            *ngIf="diagnosticsInputs$ | async as inputs"
                                            [field]="field"
                                            [customerId]="inputs.customerId"
                                            [locationId]="inputs.locationId"
                                            [deviceTypes]="inputs.deviceTypes"
                                            [monitorSeriesType]="inputs.monitorSeriesType"
                                        >
                                            <img
                                                class="img-icon-24"
                                                [ngSrc]="'/assets/images/diagnostic.jpg'"
                                                height="24"
                                                width="24"
                                            />
                                        </app-diagnostics-menu>
                                    </span>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>
        </ng-container>
    </div>
</ng-container>

<!-- Expandable Section (with mat-expansion-panel) -->
<ng-container *ngIf="section.expandable">
    <!-- Nested panel -->
    <ng-container *ngIf="isNestedSection; else topLevelPanel">
        <div
            class="nested-expansion-panel"
            [ngClass]="section.panelClass"
            [class.basic-info-section-error]="hasErrors()"
        >
            <div class="nested-panel-header" (click)="toggleExpansion($event)">
                <div class="nested-panel-title" [ngClass]="{ 'error-indicator': hasErrors() }">
                    {{ section.title | translate }}
                </div>
                <div class="nested-panel-indicators">
                    <ng-container *ngIf="hasErrors() && errorCount > 0">
                        <mat-icon class="warning-icon">warning</mat-icon>
                        <span class="error-count">
                            {{ errorCount }}
                            {{ 'HOME.MAP.MARKER_LOCATION_DETAIL.TRITON_REQUIRED_ERRORS_TXT' | translate }}
                        </span>
                    </ng-container>
                    <mat-icon class="expand-icon" [class.expanded]="section.expanded"> expand_more </mat-icon>
                </div>
            </div>

            <div class="nested-panel-content" [@expandContent]="section.expanded ? 'expanded' : 'collapsed'">
                <ng-container *ngTemplateOutlet="sectionContent"></ng-container>
            </div>
        </div>
    </ng-container>
    <!-- Top level panel -->
    <ng-template #topLevelPanel>
        <mat-expansion-panel [expanded]="section.expanded" [ngClass]="{ 'basic-info-section-error': hasErrors() }">
            <mat-expansion-panel-header class="mat-expasion-header-background" (click)="handlePanelHeaderClick($event)">
                <mat-panel-title class="input-text" [ngClass]="{ 'error-indicator': hasErrors() }">
                    {{ section.title | translate }}
                </mat-panel-title>
                <mat-panel-description *ngIf="hasErrors() && errorCount > 0">
                    <mat-icon>warning</mat-icon>
                    <span>
                        {{ errorCount }}
                        {{ 'HOME.MAP.MARKER_LOCATION_DETAIL.TRITON_REQUIRED_ERRORS_TXT' | translate }}
                    </span>
                </mat-panel-description>
                <mat-panel-description *ngIf="hasErrors() && errorCount === 0">
                    <mat-icon>warning</mat-icon> <span></span>
                </mat-panel-description>
            </mat-expansion-panel-header>

            <!-- Section Content -->
            <ng-container *ngTemplateOutlet="sectionContent"></ng-container>
        </mat-expansion-panel>
    </ng-template>
</ng-container>

<!-- Non-expandable Section (without mat-expansion-panel) -->
<ng-container *ngIf="!section.expandable">
    <div [ngClass]="section.panelClass">
        <h3 class="section-title" *ngIf="section.displayTitle">{{ section.title | translate }}</h3>
        <!-- Section Content -->
        <ng-container *ngTemplateOutlet="sectionContent"></ng-container>
    </div>
</ng-container>

<!-- Template for Section Content (reused in both expandable and non-expandable) -->
<ng-template #sectionContent>
    <!-- Standard Section Content -->
    <ng-container *ngIf="!isArraySection() && !isActionsSection()">
        <ng-container *ngFor="let row of section.rows">
            <div [ngClass]="row.panelClass" [matTooltip]="row.tooltip ? (row.tooltip | translate) : ''">
                <ng-container *ngFor="let fieldId of row.fields">
                    <ng-container *ngIf="getField(fieldId) as field">
                        <ng-container [ngSwitch]="field.type">
                            <!-- Regular field -->
                            <ng-container *ngSwitchDefault>
                                <app-field-renderer
                                    [fieldId]="fieldId"
                                    [field]="field"
                                    [control]="getFieldControl(fieldId)"
                                    [isReadOnly]="isReadOnly"
                                >
                                </app-field-renderer>
                            </ng-container>

                            <ng-container *ngSwitchCase="RowItemType.Section">
                                <app-dynamic-section
                                    [section]="field.section"
                                    [form]="getFieldControl(fieldId)"
                                    [isNestedSection]="true"
                                    [isReadOnly]="isReadOnly"
                                >
                                </app-dynamic-section>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>
        </ng-container>
    </ng-container>

    <!-- Array Section Content -->
    <ng-container *ngIf="isArraySection()">
        <div class="array-section">
            <div class="array-header" *ngIf="section.title && section.displayActionBtns">
                <h4>{{ section.title | translate }}</h4>
                <button
                    *ngIf="section.displayActionBtns"
                    mat-button
                    color="primary"
                    type="button"
                    [disabled]="isReadOnly || isMaxItemsReached()"
                    (click)="addArrayItem()"
                >
                    {{ 'COMMON.ADD_MORE' | translate }}
                </button>
            </div>

            <div class="array-row-container" *ngFor="let row of section.rows; let i = index">
                <div [ngClass]="row.panelClass" [matTooltip]="row.tooltip ? (row.tooltip | translate) : ''" class="array-row">
                    <ng-container *ngFor="let fieldId of row.fields">
                        <div class="array-field full-width">
                            <app-field-renderer
                                [fieldId]="fieldId"
                                [field]="getField(fieldId)"
                                [control]="form.controls[i]?.get(fieldId)"
                                [isReadOnly]="isReadOnly"
                            >
                            </app-field-renderer>
                        </div>
                    </ng-container>
                </div>
                <button
                    *ngIf="section.displayActionBtns"
                    (click)="removeArrayItem(i)"
                    mat-icon-button
                    type="button"
                    class="delete-button"
                    [disabled]="isReadOnly"
                >
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
        </div>
    </ng-container>
</ng-template>
